import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import SmallSelectableCards from '../SmallSelectableCards';

import './timeline.css';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  padding: 0,
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  // Tokenized stripe — theme-driven so it stays subtle and correct in dark mode
  // (was a hardcoded light grey / white-alpha pair).
  backgroundColor: theme.palette.action.hover,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));


export default function ControlledAccordions({ schedule }) {
  const [expanded, setExpanded] = React.useState(true);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='timeline-container'>
      {schedule.map((day_item, i) => {
        return (
          <Accordion key={`itinerary-timeline-${i}`} expanded={expanded === day_item.dayTime} onChange={handleChange(day_item.dayTime)}>
            <AccordionSummary
              expandIcon={null}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography sx={{ width: '33%', color: 'text.secondary' }}>
                {day_item.time}
              </Typography>
              <Typography sx={{ flexShrink: 0 }} >{day_item.dayTime}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                {day_item.description}
              </Typography>
              {/* A section is omitted rather than rendered as a heading above
                  "None listed." There are no published Restaurants anywhere in
                  the country today, so every day of every itinerary carried an
                  empty Restaurants row — which reads as the page being broken
                  rather than as the catalogue being thin. */}
              {day_item.restaurants?.length > 0 && (
                <SmallSelectableCards title="Restaurants" list={day_item.restaurants} />
              )}
              {day_item.activities?.length > 0 && (
                <SmallSelectableCards title="Things To Do" list={day_item.activities} />
              )}
            </AccordionDetails>
          </Accordion>
        )
      })}
    </div>
  );
}